import React, { createContext, useState } from "react";
import FirebaseNewAdapter from "./FirebaseNewAdapter";

export const FirebaseNewContext = createContext('');

const FirebaseNewContextProvider = (props) => {
    const [firebase] = useState(new FirebaseNewAdapter());

    return (
        <FirebaseNewContext.Provider value={{ firebase }}>
            {props.children}
        </FirebaseNewContext.Provider>
    )
}

export default FirebaseNewContextProvider
